/**
 * Horwath HTL Brand Colors
 */
export const brandColors = {
    // Primary Colors
    gold: '#FFCC00',
    indigo: '#607D8B',
    blue: '#000033',
    // Neutral Colors
    white: '#FFFFFF',
    grayLight: '#F8F9FA',
    grayMedium: '#686E77',
    grayDark: '#32373C',
    // Semantic Colors
    success: '#28A745',
    warning: '#FFCC00',
    error: '#C4161C',
    info: '#97a3c2',
};
// CSS Variable names for runtime theming
export const cssVariables = {
    '--color-gold': brandColors.gold,
    '--color-indigo': brandColors.indigo,
    '--color-blue': brandColors.blue,
    '--color-white': brandColors.white,
    '--color-gray-light': brandColors.grayLight,
    '--color-gray-medium': brandColors.grayMedium,
    '--color-gray-dark': brandColors.grayDark,
};
//# sourceMappingURL=colors.js.map